<!-- src/components/MyComponent.vue -->
<template>
    <div class="my-skeleton">
      <van-skeleton title :row="row" />
    </div>
  </template>
  <script>
  export default {
    name: "MySkeleton",
    props: {
      row: {
        type: Number,
        default: 20,
      },
      // 可以根据需要添加 props
    },
  };
  </script>
  
  <style>
  .my-skeleton {
    
    padding: 20px;
  }
  </style>
  